import React from "react";

import { ReactComponent as SeamlessCommunication } from "src/assets/icons/home-benefits/seamless-communication.svg";
import { ReactComponent as RegulatoryAdherence } from "src/assets/icons/home-benefits/regulatory-adherence.svg";
import { ReactComponent as RealTimeInsights } from "src/assets/icons/home-benefits/real-time-insights.svg";
import { ReactComponent as DataDrivenDecisionMaking } from "src/assets/icons/home-benefits/data-driven-decision-making.svg";
import { ReactComponent as EfficiencyAndSafety } from "src/assets/icons/home-benefits/efficiency-and-safety.svg";
import { ReactComponent as PaveTheWayForAIAdoption } from "src/assets/icons/home-benefits/pave-the-way-for-AI-adoption.svg";
import { ReactComponent as Expand } from "src/assets/icons/home-benefits/expand.svg";

import homeConfig from "src/resources/homePage.json";
import { Trans, useTranslation } from "react-i18next";

import { Button } from "primereact/button";
const Benefits = () => {
  const { t } = useTranslation(["common", "homePage"]);

  const [isOverlayShown, setIsOverlayShown] = React.useState(false);
  const [activeCardIndex, setActiveCardIndex] = React.useState(-1);
  const showContent = (index: number) => {
    setIsOverlayShown(true);
    setActiveCardIndex(index);
  };
  const benefits = homeConfig.benefits;
  return (
    <section
      className="home-section benefits why-hassantuk w-100"
      id="benefits"
    >
      <Trans>
        <div className="main-benefit d-flex flex-column m-auto w-80">
          <h2 className="text-center">{t(`homePage.benefits.title`)}</h2>
          <p className="text-center w-70 m-auto w-md-100">
            {t(`homePage.benefits.subTitle`)}
          </p>
        </div>
        <div className="benefits-cards w-75">
          {benefits.items.map((item, index) => (
            <div
              className="benefit-card d-flex flex-column justify-content-center align-items-center gap-3"
              key={index}
            >
              <div className="benefit-card-content  d-flex flex-column justify-content-center align-items-center gap-3">
                {item.icon === "SeamlessCommunication" && (
                  <SeamlessCommunication />
                )}
                {item.icon === "RegulatoryAdherence" && <RegulatoryAdherence />}
                {item.icon === "RealTimeInsights" && <RealTimeInsights />}
                {item.icon === "DataDrivenDecisionMaking" && (
                  <DataDrivenDecisionMaking />
                )}
                {item.icon === "EfficiencyAndSafety" && <EfficiencyAndSafety />}
                {item.icon === "PaveTheWayForAIAdoption" && (
                  <PaveTheWayForAIAdoption />
                )}
                <h4>{t(`homePage.benefits.items.item${index + 1}.title`)}</h4>
              </div>
              <Button
                className="primary-btn border-radius-100 d-flex gap-2 m-0"
                label={t("details")}
                icon={<Expand className="expand-icon" />}
                onClick={() => showContent(index)}
              ></Button>

              <div
                className={`card-overlay d-flex flex-column ${
                  isOverlayShown && activeCardIndex === index ? "active" : ""
                }`}
                onClick={() => setIsOverlayShown(false)}
              >
                <h4>{t(`homePage.benefits.items.item${index + 1}.title`)}</h4>
                <p>{t(`homePage.benefits.items.item${index + 1}.content`)}</p>
              </div>
            </div>
          ))}
        </div>
        <div>
          <h4 className="text-center w-50 m-auto benefit-note">
            {t(`homePage.benefits.note`)}
          </h4>
        </div>
      </Trans>
    </section>
  );
};

export default Benefits;
